// extracted by mini-css-extract-plugin
export default {"reaction":"ybmWU","android":"oUi8g"};